// Vocabulario de Opta: los valores que el feed espera recibir y devuelve.

/** Estados de partido, tal como los nombra Opta. Se pueden combinar con coma. */
export const optaMatchStatus = {
    all: "all",
    fixture: "Fixture",
    playing: "Playing",
    played: "Played",
    fixtureOrPlaying: "Fixture,Playing",
    fixtureOrPlayed: "Fixture,Played",
};

/**
 * Tamaño de página por consulta: lo define el volumen de partidos de cada torneo.
 */
export const optaPageSize = {
    cupSeason: 800,
    leagueSeason: 700,
    ligaCopaSeason: 600,
    ligaCopaWeek: 500,
    teamSeason: 100,
    firstMatch: 1,
};
